import { createReducer, Action, on } from '@ngrx/store';

import * as SalesOrderPeriodActions from './sales-order-period.actions';
import { SalesOrderPeriodState } from '../models/sales-order-period.models';

const reducer = createReducer<SalesOrderPeriodState>(
  {},
  on(SalesOrderPeriodActions.setSalesOrderPeriods, (state, { salesOrderPeriods }) => ({
    ...state,
    salesOrderPeriods,
  })),
);

export const salesOrderPeriodReducer = (state: SalesOrderPeriodState | undefined, action: Action) =>
  reducer(state, action);
